
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Career from "../home/career"

export default class CareerTracks extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content px-0"> 
          <Career></Career>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/ivano/careerTracks.jsx